import React, { useCallback, useEffect, useState } from "react"
import { checkoutLogin, redirectByUrl, runAtNextFrame } from '@yuanfudao/metis-unified-login'
import { isElectron } from '@/utils/os'
import { BridgeAppReady, bridgeData } from '@/electron'
import { getSchoolSearch } from "@/utils/common"
import { ProjectConfig } from "@/project-config"

import lessModule from "./index.module.less"
import { Checkbox } from "@yuanfudao/metis-web-component"
import config from "@/config"
import { useMsgFail } from "@yuanfudao/metis-unified-login/es/utils/antd-message"

export default function ShLogin() {
  const { getLoginUrl } = ProjectConfig
  const [isCheckAgreement, setIsCheckAgreement] = useState<boolean>(false)
  const [checkboxWrapClass, setCheckboxWrapClass] = useState('')

  const MsgFail = useMsgFail()

  const onNotAgree = () => {
    setCheckboxWrapClass(lessModule.checkboxHover)
    setTimeout(() => {
      setCheckboxWrapClass('')
    }, 1000)
  }

  const Agreement = (
    <div
      className={`${lessModule.agreement} ${checkboxWrapClass}`}
      style={{
        bottom: '26px',
      }}
    >
      <Checkbox
        checked={isCheckAgreement}
        onChange={(e) => {
          setIsCheckAgreement(e.target.checked)
        }}
      />
      <div className={lessModule.textWrap} onClick={(e) => e.stopPropagation()}>
        我已阅读并同意
        <span
          className={lessModule.link}
          onClick={() => {
            if (isElectron) {
              window.require("electron").shell.openExternal(config.zhzxjsPrivacy)
              return
            }
            window.open(config.zhzxjsPrivacy, "_blank")
          }}
        >
          《隐私政策》
        </span>
        <span
          className={lessModule.link}
          onClick={() => {
            if (isElectron) {
              window.require("electron").shell.openExternal(config.zhzxjsChildPrivacy)
              return
            }
            window.open(config.zhzxjsChildPrivacy, "_blank")
          }}
        >
          《儿童隐私保护政策》
        </span>
      </div>
    </div>
  )

  const jumpToShLogin = useCallback(() => {
    if (!isCheckAgreement) {
      // setLoginErrText('请先阅读并勾选底部的协议')
      MsgFail('请先阅读并勾选底部的协议')
      onNotAgree()
      return
    }
    if (getLoginUrl && getLoginUrl instanceof Function) {
      window.location.href = `${getLoginUrl(getSchoolSearch())}`
    }
  }, [MsgFail, getLoginUrl, isCheckAgreement])

  useEffect(() => {
    runAtNextFrame(() => {
      runAtNextFrame(() => {
        if (isElectron && !bridgeData.bridgeAppReady) {
          BridgeAppReady()
        }
      })
    })
    const init = async () => {
      const login = await checkoutLogin()
      if (login) {
        redirectByUrl()
        return
      }
    }
    init()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      className={`${lessModule.loginWrap} blur-bg`}
      id="loginWrap"
      style={{
        height: '420px',
        minHeight: '420px',
      }}
    >
      <div className={lessModule.textBox}>
        <span>点击登录按钮</span>
        <span>跳转「上海智慧教育平台」完成登录</span>
      </div>
      <div className={lessModule.btn} onClick={jumpToShLogin}>
        登录
      </div>
      {Agreement}
    </div>
  )
}
